import { axiosUtils } from "../../../network/axiosUtils";
import httpRequest from "../../../network/httpRequest";
import speedMateHttpRequest from "../../../network/speedMateHttpRequest";
import { HttpResponse } from "../../../network/types";
import { MESSAGE_KIND } from "./constants";
import {
  SignInResponse,
  SignInRequest,
  SendPhoneNumberRequest,
  CheckTokenRequest,
  SpeedMateSignInRequest,
  AutoOasisSignInRequest,
  SignInCrewRequest,
} from "./types";

export const SignIn = async (props: SignInRequest) => {
  const requestBody = {
    ...props,
    phone: props.repairShopPhone,
  };
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: `/repair-shop/signin`,
    requestBody,
  });

  const res: SignInResponse = {
    admin: response?.data.row,
    accessToken:
      response?.headers.Authorization || response?.headers.authorization,
  };
  return res;
};

export const SignInCrew = async (requestBody: SignInCrewRequest) => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: `/repair-shop/signin-crew`,
    requestBody,
  });
  const res: SignInResponse = {
    admin: response?.data.row,
    accessToken:
      response?.headers.Authorization || response?.headers.authorization,
  };
  return res;
};

export const SendPhoneNumber = async (props: SendPhoneNumberRequest) => {
  const requestBody = {
    ...props,
    type: "message",
    kind: MESSAGE_KIND,
  };
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: `/auth-tokens`,
    requestBody,
  });
  return response?.data.row;
};
export const CheckPhoneAuth = async (props: CheckTokenRequest) => {
  const requestBody = {
    ...props,
    type: "message",
    kind: MESSAGE_KIND,
  };
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: `/access-tokens`,
    requestBody,
  });
  return response?.data.row;
};
export const speedMateLogin = async (requestBody: SpeedMateSignInRequest) => {
  const response: HttpResponse = await speedMateHttpRequest({
    method: axiosUtils.POST,
    url: `/repair-shop/signin-speed-mate`,
    requestBody,
  });
  const res: SignInResponse = {
    admin: response?.data.row,
    accessToken:
      response?.headers.Authorization || response?.headers.authorization,
  };
  return res;
};
export const autoOasisLogin = async (requestBody: AutoOasisSignInRequest) => {
  const response: HttpResponse = await speedMateHttpRequest({
    method: axiosUtils.POST,
    url: `/repair-shop/signin-gs-mbiz`,
    requestBody,
  });
  const res: SignInResponse = {
    admin: response?.data.row,
    accessToken:
      response?.headers.Authorization || response?.headers.authorization,
  };
  return res;
};
